import { DOMRef } from '@react-types/shared'
import { OpenTransition } from '../OpenTransition'
import { OverlayProps } from '@react-types/overlays'
import { theme } from '@react-spectrum/theme-default'
import { Provider } from '../SpectrumProvider'
import React, { useCallback, useState } from 'react'
import ReactDOM from 'react-dom'

function Overlay(props: OverlayProps, ref: DOMRef<HTMLDivElement>) {
  const {
    children,
    isOpen,
    container,
    onEnter,
    onEntering,
    onEntered,
    onExit,
    onExiting,
    onExited
  } = props
  const [exited, setExited] = useState(!isOpen)

  const handleEntered = useCallback(() => {
    setExited(false)
    if (onEntered) {
      onEntered()
    }
  }, [onEntered])

  const handleExited = useCallback(() => {
    setExited(true)
    if (onExited) {
      onExited()
    }
  }, [onExited])

  const mountOverlay = isOpen || !exited
  if (!mountOverlay) {
    return null
  }

  const contents = (
    <Provider
      ref={ref}
      UNSAFE_style={{ background: 'transparent', isolation: 'isolate' }}
      theme={theme}
    >
      <OpenTransition
        in={isOpen}
        appear
        onExit={onExit}
        onExiting={onExiting}
        onExited={handleExited}
        onEnter={onEnter}
        onEntering={onEntering}
        onEntered={handleEntered}
      >
        {children}
      </OpenTransition>
    </Provider>
  )

  return ReactDOM.createPortal(contents, container || document.body)
}

const _Overlay = React.forwardRef(Overlay)
export { _Overlay as Overlay }
